
import { Component, Vue, } from "vue-property-decorator";
import { dispatchGetUserXcoinPackages } from "@/store/mlm/actions";
import { readUserXcoinPackages } from "@/store/mlm/getters";
@Component({
  components: {
  }
})
export default class UserXcoinOrders extends Vue {
  public loadingState: boolean = false;
 

  public get userXCoinPackages() {
    return readUserXcoinPackages(this.$store);
  }

  public formatDate(date: string): string {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    }

  public async mounted() {
   if (this.userXCoinPackages.length > 0) {
    return; // данные уже есть
  }

  this.loadingState = true;
  try {
    await dispatchGetUserXcoinPackages(this.$store);
  } finally {
    this.loadingState = false;
  }
  }
}
